import { render, staticRenderFns } from "./ThreadEditAnswer.vue?vue&type=template&id=ecfb0c72&"
import script from "./ThreadEditAnswer.vue?vue&type=script&lang=js&"
export * from "./ThreadEditAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports